// Put your application javascript here
$(document).ready(function () {

  // On récupère la langue en cours
  var site_lng = $("html").attr("lang");

  // Plugin sticky partout sauf sur les pages avec un header fixed (home, lookbook, page produit)
  $("#shopify-section-header:not(.fixed_header #shopify-section-header)").sticky();

  // Gestion des comportements stickys sur le header
  $(document).scroll(function (e) {
    if ($(window).scrollTop() >= 26) {
      $("#shopify-section-header").addClass("sticky");
    }
    else {
      $("#shopify-section-header").removeClass("sticky");
    }
    return false;
  });

  // Barre de recherche, ouverture et fermeture
  $('.search_btn').click(function (e) {
    e.preventDefault();
    $('.search_bar').slideDown(100);
    $('#search_bar_input').focus();
  });

  $('.close_search').click(function (e) {
    e.preventDefault();
    $('.search_bar').slideUp(100);
  });

  // Back to top
  $('#back').click(function (ev) {
    $('html, body').animate({ scrollTop: 0 }, 500);
    return false;
  });

  // Ouverture menu mobile
  $("#burger").click(function (e) {
    $("#main_nav").slideToggle(200);
    $(this).toggleClass('on');
  });

  // Apparition popin panier
  $('.cart').hover(function () {
    if ($('#cart_pop').is(":hidden")) {
      $('#cart_pop').fadeIn(50);
    }
  });

  $('.close_cart_pop').click(function (e) {
    $('#cart_pop').fadeOut(50);
  });

  // Transition ouverture méga menu
  if ($(window).width() >= 768) {
    $("#main_nav .level-1").hover(function (e) {
      $("#shopify-section-header .global_wrap").addClass("focus");
      $("div.wrapper").not($(this).find("div.wrapper")).fadeOut(100);
      $(this).find("div.wrapper").stop().fadeIn(200);
    }, function (e) {
      $("#shopify-section-header .global_wrap").removeClass("focus");
      $(this).find("div.wrapper").stop().fadeOut(200);
    });
  } else {
    $("#main_nav .level-1 > a").click(function (e) {
      if ($(this).parent().hasClass('no-child')) { }
      else {
        e.preventDefault();
      }
      $(this).next("div.wrapper").stop().slideToggle(150);
    });
  }

  // Apparition du guide des tailles
  $("#size_legend").on('click', function () {
    $("#sizing-guide").show();
  });

  // Ouverture popin de réactivation de compte
  $("#reactivate_btn").on('click', function () {
    $("#reactivate_popin").show();
  });

  // Gestion de la réactivation d'email
  $(document).on("submit", "#reactivate_popin form", function (e) {
    e.preventDefault();
    var $that = $(this);
    $that.find(".Alert--error").hide();
    $.ajax({
      url: $(this).data("target"),
      method: "post",
      dataType: 'json',
      data: $(this).serialize() + "&lng=" + $that.data("lng")
    })
      .done(function (data) {
        if (!data.success) {
          $that.find(".Alert--error").html(data.msg).show();
        }
        else {
          if ($that.data("lng") == "fr") {
            $(".js-reactivation-title").html("Merci");
            $(".js-reactivation-instruction").hide();
            $that.replaceWith('<div class="success"><p>Votre compte a bien été identifié, nous venons de vous faire parvenir un email pour le réactiver.</p></div>');
          }
          else {
            $that.prev("h3").html("Thank you");
            $that.replaceWith('<div class="success"><p>Your account has been identified, we\'ve just sent you an email to reactivate it.</p></div>');
          }
        }
      });
  })

  // Fermeture des popins
  $(document).on("click", ".popin .close", function (ev) {
    $('.popin').fadeOut(200);
  });

  // Slider de la home page
  $(".slider").slick({
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    fade: true,
    autoplaySpeed: 3000,
    pauseOnHover: false,
    autoplay: true
  });

  if ($(window).width() <= 767) {
    $(".elx-products-list:not(.no_carrousel_mobile)").slick({
      dots: true,
      arrows: false,
      infinite: true,
      centerMode: true,
    });
  }

  if ($(window).width() <= 767) {
    $(".elx-products-list-2:not(.no_carrousel_mobile)").slick({
      dots: true,
      arrows: false,
      infinite: true,
      centerMode: true,
    });
  }

  // Popin d'inscription newsletter en homepage
  var PromoCookie = {};
  PromoCookie.cookie = {
    configuration: {
      expires: null, //session cookie
      path: '/',
      domain: window.location.hostname
    },
    name: 'newsletter_home',
    write: function (promo) {
      $.cookie(this.name, promo, this.configuration);
    },
    read: function () {
      return $.cookie(this.name);
    }
  };
  var cookieExists = PromoCookie.cookie.read();

  if (!cookieExists) {
    PromoCookie.cookie.write('newsletter_home');
    var $thisModal = $('#newsletter_popin');
    $thisModal.delay(7000).fadeIn('fast');
  }
  else {
    // Si l'url contient "?customer_posted=true", on doit afficher la popin également
    let searchParams = new URLSearchParams(window.location.search);
    if (searchParams.has('customer_posted')) {
      var $thisModal = $('#newsletter_popin');
      $thisModal.fadeIn('fast');
    }
  }

  // Page listing produits
  /*********************************************************************************************** */

  // Switch layout
  $(".grid.xs").click(function (e) {
    $(".grid").removeClass("selected");
    $(this).addClass("selected");
    $("#collection .listing").removeClass().addClass("listing").addClass("solo_grid");
  });

  $(".grid.sm").click(function (e) {
    $(".grid").removeClass("selected");
    $(this).addClass("selected");
    $("#collection .listing").removeClass().addClass("listing").addClass("two_grid");
  });

  $(".grid.lg").click(function (e) {
    $(".grid").removeClass("selected");
    $(this).addClass("selected");
    $("#collection .listing").removeClass().addClass("listing").addClass("three_grid");
  });

  // Open filters box
  $("#filters_icon").click(function (e) {
    $("#navigation").fadeIn(400);
    $("#filters").addClass("opened");
  });

  // Close filters box
  $("#filters #close").click(function (e) {
    close_filters();
  });

  // Open filters lists
  $("#filters .type").click(function (e) {
    $(this).toggleClass("open");
    $(this).next(".type_content").slideToggle(100);
  });

  // Close filters and popins when pressing escape
  $(document).keyup(function (e) {
    if (e.keyCode === 27) {
      if ($("#filters:visible").length) {
        close_filters();
      }
      if ($('.popin:visible').length) {
        $('.popin').fadeOut(200);
      }
    }
  });

  // Fermeture des filtres
  function close_filters() {
    $("#navigation").fadeOut(400);
    $("#filters").removeClass("opened");
  }

  // Click sur une taille de produit
  $('.size_link').click(function (e) {
    e.preventDefault();
    window.location.href = $(this).data('size_id');
  })



  // Page produit
  /*********************************************************************************************** */

  // Carousel slick sur version mobile
  if ($(window).width() <= 767) {
    $(".product_images").slick({
      dots: true,
      arrows: false,
      infinite: true,
      speed: 500,
      fade: true,
      adaptiveHeight: true,
      autoplay: false
    });
  }

  // Zoom sur les photos produits uniquement en desktop
  if ($(window).width() > 1024 && $('.zoomable').length) {
    $('.zoomable').zoom({ url: $(this).data("zoom"), on: 'click' });
  }

  // A la sélection d'une taille, on vérifie sa dispo et on met à jour le bouton
  $('.radio_size input').change(function (e) {
    if ($(this).data('available') == false) {
      $('#AddToCart').addClass('hidden');
      setTimeout(function () { $('#SI_trigger').removeAttr('style'); }, 200);
    }
    else {
      $('#AddToCart').removeClass('hidden');
      $('#SI_trigger').removeAttr('style');
    }

    // Mise à jour du bouton Socloz
    $("#e-resa").attr("data-socloz-product-attributes-clothes_size", $(this).parent().data("size"));
  });

  // Déplacement du <hr> sous le titre de caractéristique sélectionné
  $(".entetes div").hover(function (e) {
    var $hr = $(".entetes hr");

    $hr.css("width", $(this).children("span").innerWidth());
    $hr.css("left", $(this).stop().position().left);
  });

  // Ouverture des caractéristiques
  $(".entetes div").click(function (e) {
    var data = $(this).data("open");

    $(".entetes div").removeClass("opened");
    $(this).addClass("opened");

    $(".desc .content > div").hide();
    $(".desc .content div[data-toggle=" + data + "]").show().addClass("opened");
  });

  // Changement de section entre le cross-selling et les produits récemment vus
  $("#other_products_titles h2").on('click', function () {
    $("#other_products_titles h2").removeClass("actif");
    $(this).addClass("actif");

    var target_section = $(this).data("target");
    $('.cross_panel').not('#' + target_section).fadeOut(0);
    $('#' + target_section).fadeIn(100);
    $('#' + target_section + ' .product-item').show();
  });


  // Panier
  /*********************************************************************************************** */
  // Affichage du pannel commande cadeau
  $("#is_gift").click(function () {
    if ($(this).is(':checked') == true) {
      $('#message_box').fadeIn(100);
    } else {
      $('#message_box').fadeOut(100);
    }
  })

  // Empeche les retours à la ligne dans la texte area.
  $("#gift_message").keypress(function (e) {
    if (e.keyCode != 13) return;
    var msg = $("#gift_message").val().replace("\n", "");
    return false;
  });


  // Store locator
  /*********************************************************************************************** */
  // Ouverture des informations supplémentaire
  $("#store_locator .more").click(function () {
    $(this).next(".horaires").fadeToggle(150);
  });

  $("#store_locator .js-centermap").click(function () {
    var center = { lat: $(this).data("lat"), lng: $(this).data("long") }
    map.setCenter(center);
    map.setZoom(15);
  });

  /* Concaténation date et mois de naissance lors de la créatin de compte et inscription newsletter */
  $('#create_customer').submit(function (e) {
    var dob = $("#dob").val();
    var mob = $("#mob").val();
    var yob = $("#yob").val();

    if (dob && mob && yob) {
      var full_dob = "dob:" + dob + "-" + mob + "-" + yob;
      $('#full_dob').val(full_dob);
    }
  });

  /* Concaténation date et mois de naissance lors de l'inscription newsletter */
  $('.birthday select').change(function (e) {
    var dob = $("#dob").val();
    var mob = $("#mob").val();
    var yob = $("#yob").val();

    if (dob && mob && yob) {
      var full_dob = "dob:" + dob + "-" + mob + "-" + yob;
      $('#full_dob').val("newsletter, " + full_dob);
    }
  });

  /* Concaténation date et mois de naissance lors de l'inscription depuis la page "inscription" */
  $('#popin_nl_cta').change(function (e) {
    var dob = $("#dob").val();
    var mob = $("#mob").val();
    var yob = $("#yob").val();

    if (dob && mob && yob) {
      var full_dob = "dob:" + dob + "-" + mob + "-" + yob;
      $('#full_dob').val("newsletter, " + full_dob);
    }
  });

  // FAQ
  if ($(".page-faq").length) {
    $(".faq_title").click(function (e) {
      $('.faq_title').removeClass('open');
      if (!$(this).parent().find(".faq_list").hasClass("opened")) {
        $(this).addClass("open");
        $(".faq_list.opened").slideToggle(300, "linear", function () { $(this).removeClass("opened"); });
        $(this).parent().find(".faq_list").slideToggle(300, "linear", function () { $(this).addClass("opened"); });
      }
      else {
        $(this).removeClass('open');
        $(".faq_list.opened").slideToggle(300, "linear", function () {
          $(this).removeClass("opened");
        });
      }
    });
  }

});

// Mise à jour des quantités dans le panier, en récupérant les évènements de cart.js
// https://cartjs.org/pages/reference#events
$(document).on('cart.requestComplete', function (event, cart) {

  // On récupère la langue en cours
  var site_lng = $("html").attr("lang");

  $('.cart .nbitems, .cart_btn .nbitems').html(cart.item_count); // MAJ compteur dans le panier

  var new_basket = '';

  $.each(cart.items, function (i, item) {
    var normal_price = item.original_price != item.price ? '<span class="discount">' + item.original_price / 100 + '€</span>' : '';

    new_basket += '<div class="line_item_pop">' +
      '<div class="line_item_desc"><p class="line_item_title">' +
      '<a href="' + item.url + '">' + item.product_title + '</a><br>' +
      'Taille : ' + item.variant_title + '<br>' + normal_price +
      (item.price / 100) + '€<br>x' + item.quantity + '<br/><span class="remove_item" data-cart-remove-id="' + item.id + '">Retirer</span></p>' +
      '</div>' +
      '<div class="line_item_img">' +
      '<a href="' + item.url + '">' +
      '<img src="' + item.featured_image.url.replace(".jpg", "_x100.jpg") + '" alt="' + item.featured_image.url + '"></a>' +
      '</div></div>';
  });

  $('.items_list').html(new_basket);

  if (cart.items.length) {
    $('.empty_alert').hide();
  }
  else {
    $('.empty_alert').show();
  }

  // Si on n'est pas sur la page panier
  if (!$("#shopify-section-cart-elx").length) {
    $('#cart_pop').fadeIn(150);
  }
  else {
    location.reload();
  }
});
